import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Button,
  Collapse,
  List,
  withStyles,
  makeStyles
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { ImageIcon } from 'src/app/utils/UltilsComponents';
import { Typography } from 'antd';
import MuiListItem from "@material-ui/core/ListItem";
const ListItem = withStyles({
  root: {
    "&:hover": {
      backgroundColor: "#fff2f3",
      color: "white",

      "& .MuiListItemIcon-root": {
        color: "white"
      }
    },
  },
  // root: {
  //   '&$selected': {
  //     backgroundColor: 'red',
  //     '&:hover': {
  //       backgroundColor: 'yellow',
  //     }
  //   },
  // },
  selected: {}
})(MuiListItem);

const useStyles = makeStyles(theme => ({
  
  image: {
    marginRight: "5px"
  },
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: 'flex-start',
    letterSpacing: 0,
    padding: '10px 16px',
    textTransform: 'none',
    width: '100%',
  },
  icon: {
    marginRight: theme.spacing(1),
    color: '#313131'
  },
  title: {
    marginRight: 'auto',
    fontWeight: 500,
    color: '#313131',
    fontSize: '14px',

    
  },
  subTitle: {
    fontWeight: 400,
    paddingLeft:'15px',
  },
  active: {
    color: theme.palette.primary.main,
    '& $title': {
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.primary.main
    },
    '& $icon': {
      color: theme.palette.primary.main
    },
    backgroundColor:'#fff2f2',
    borderRadius:'none',
    borderRight:'4px solid #D9042F',
  },
  nested: {
    paddingLeft: 0,
    '& a:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.background.light,
    }
  }
}));
const NavItemDN = ({
  className,
  href,
  title,
  arrayNested,
  ...rest
}) => {
  const classes = useStyles();
  const [openTab, setOpenTab] = React.useState(false);
  const location = useLocation();
  const pathName = location.pathname;
  const hasActiveChild = Boolean(
    arrayNested?.some(item => item.href === pathName)
  );

  React.useEffect(() => {
    setOpenTab(hasActiveChild);
  }, [hasActiveChild]);
  
  return (
    <>
      <ListItem
        className={clsx(classes.item, className)}
        disableGutters
        {...rest}
        onClick={() => {
          if (!arrayNested) return;
          setOpenTab(!openTab);
        }}
      >
        <Button
          className={clsx(classes.button, {
            [classes.active]: href ? href === pathName : false
          })}
          component={href ? RouterLink : Button}
          {...(href ? { to: href } : {})}
        >
          <Typography style={{marginTop:2}} className={classes.title}>{title}</Typography>
          {arrayNested && (openTab ? <ExpandLess /> : <ExpandMore />)}
        </Button>
      </ListItem>
      <List component={'div'}>
        {arrayNested &&
          arrayNested.map(item => (
            <Collapse
              in={openTab}
              timeout="auto"
              unmountOnExit
              key={item.title}
            >
              <ListItem
                style={{padding:'0'}}
                className={clsx(classes.nested, className)}
                disableGutters
                {...rest}
              >
                <Button
                  className={clsx(classes.button, {
                    [classes.active]: item.href === pathName
                  })}
                  component={RouterLink}
                  to={item.href}
                >
                  {item.icon && item.icon}
                  <span className={classes.subTitle}>{item.title}</span>
                </Button>
              </ListItem>
            </Collapse>
          ))}
      </List>
    </>
  );
};

NavItemDN.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.element,
  title: PropTypes.string,
  arrayNested: PropTypes.array
};

export default NavItemDN;
